import { render, staticRenderFns } from "./RevisionesForm.vue?vue&type=template&id=8085fac0&"
import script from "./RevisionesForm.vue?vue&type=script&lang=js&"
export * from "./RevisionesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports